import {request} from '../http';
import domain from '../domain';

var ImageService = function(){
	if(domain.env === 'online'){
		this.domain = "//img.51tiangou.com";
	}else{
		this.domain = "//img." + domain.env + ".66buy.com.cn";
	}
};

ImageService.prototype._serviceAjaxCom = function(url,params){
	params.url = this.domain + url;
	request(params);
};

/**
 * 异步上传图片
 * @param   {Object}    params
 * @param   {FormData}  params.data
 * @param   {File}      params.data.file
 * @param   {String}    [params.type='POST']
 * @param   {Boolean}   [params.processData=false]
 * @param   {Boolean}   [params.contentType=false]
 * @param   {Function}  params.success
 * */
ImageService.prototype.syncImg = function(params){
	params.type = 'POST';

	params.processData = false;
	params.contentType = false;
	this._serviceAjaxCom("/fileUploader/syncImg", params);
};
// /**
//  * 同步上传图片
//  * @param   {Object}    params
//  * @param   {FormData}  params.data
//  * @param   {File}      params.data.file
//  * @param   {Function}  params.success
//  * */
// ImageService.prototype.upload = function(params){
// 	params.type = 'POST';
// 	params.async = false;
// 	this._serviceAjaxCom("/fileUploader/syncImg", params);
// };

export default new ImageService();